export const REVIEWS_TOUR_LANDING_START = "REVIEWS_TOUR_LANDING_START";
export const REVIEWS_TOUR_LANDING_SUCCESS = "REVIEWS_TOUR_LANDING_SUCCESS";
export const REVIEWS_TOUR_LANDING_ERROR = "REVIEWS_TOUR_LANDING_ERROR";

export const SHOW_ALL_TOUR_REVIEW_START = "SHOW_ALL_TOUR_REVIEW_START";
export const SHOW_ALL_TOUR_REVIEW_SUCCESS = "SHOW_ALL_TOUR_REVIEW_SUCCESS";
export const SHOW_ALL_TOUR_REVIEW_ERROR = "SHOW_ALL_TOUR_REVIEW_ERROR";
export const AVERAGE_ALL_RATE_SUCCESS = "AVERAGE_ALL_RATE_SUCCESS";